package studio.goodegg.capsule.ui

object Logos
